<template>
  <div class="project-detail-wrapper">
    <h1 class="heading-page">
        {{currentProjectName}}
    </h1>
    <Tab class="tab-padding-top-0 tab-general" defaultActiveKey="general">
      <a-tab-pane key="general" tab="General">
        <Gerneral v-if="project" :project="project" />
      </a-tab-pane>
    </Tab>
    <Tab class="tab-padding-top-0" defaultActiveKey="authentication">
      <a-tab-pane key="authentication" tab="Authentication" force-render>
        <Authentication v-if="project" :project="project" />
      </a-tab-pane>
    </Tab>
  </div>
</template>

<script type="ts">
import { defineComponent } from 'vue';
import get from 'lodash/fp/get';
import find from 'lodash/fp/find';

import Tab from '@/components/Tab/template.vue';
import Gerneral from './General/template.vue';
import Authentication from './Authentication/template.vue';
import { projectsMapper } from '../../store';
import Project from '../../models/Project';
import './styles.scss';

export default defineComponent({
  name: 'ProjectDetails',
  components: {
    Tab,
    Gerneral,
    Authentication,
  },
  props: {
    project: {
      type: Project,
    },
  },
  data() {
    return {
      dynamicAttrsTab: {
        defaultActiveKey: 'general',
        class: 'tab-padding-top-0',
      },
    };
  },
  computed: {
    ...projectsMapper.mapState(['projects']),
    currentProject() {
      const currentProjectSlug = get('_value.params.slug', this.$router.currentRoute);
      const currentProject = find((item) => get('slug', item) === currentProjectSlug, this.projects);
      return currentProject;
    },
    currentProjectName() {
      const currProject = this.currentProject;
      return get('name', currProject) || '';
    },
  },
});
</script>
